import React from "react";
import { WarningOutlined, ExclamationCircleFilled } from "@ant-design/icons";
import { CompanyCardData } from "./types";

interface Props {
  risks: CompanyCardData["risks"];
}

const RiskWarning: React.FC<Props> = ({ risks }) => (
  <div className="bg-[#F6ECD7] border border-[#B07A1E] rounded-[18px] p-6 shadow-md mb-[18px]">
    {/* Header */}
    <div className="flex items-center justify-between gap-3 mb-4">
      <div className="flex items-center gap-3 min-w-0">
        <div className="w-[38px] h-[38px] rounded-[11px] bg-white text-[#B07A1E] flex items-center justify-center text-xl flex-shrink-0">
          <WarningOutlined />
        </div>
        <div className="min-w-0">
          <h3 className="font-serif text-[19px] font-semibold text-[#B07A1E] m-0">
            How you could lose money
          </h3>
          <p className="text-[12.5px] text-[#B07A1E] m-0 mt-0.5 opacity-80">
            Read this part as carefully as the rest
          </p>
        </div>
      </div>
    </div>

    <p className="text-[15px] text-[#23312E] m-0 mb-3">
      A strong company is not the same as a rising share price. Here's what
      could go wrong:
    </p>

    <ul className="m-0 p-0 list-none flex flex-col gap-2.5">
      {risks.map((risk, i) => (
        <li
          key={i}
          className="flex gap-2.5 text-[14px] text-[#23312E] items-start"
        >
          <ExclamationCircleFilled
            className="text-[#B07A1E] mt-0.5 flex-shrink-0"
            style={{ fontSize: 16 }}
          />
          <span dangerouslySetInnerHTML={{ __html: risk }} />
        </li>
      ))}
    </ul>
  </div>
);

export default RiskWarning;
